/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrepareEmailUpdateRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {PrepareEmailUpdateResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const prepareEmailUpdate = (request: PrepareEmailUpdateRequest, options?: CashRequestOptions) => post<PrepareEmailUpdateRequest, PrepareEmailUpdateResponse>("/2.0/cash/prepare-email-update", request, {...options, rejectOnError: true })